import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { FontAwesome } from '@expo/vector-icons'
import { useNavigation } from '@react-navigation/native'
import { useUser } from '@vatom/sdk/react'
import { Avatar, PressableOpacity, theme } from '@vatom/wombo'
import { observer } from 'mobx-react-lite'
import { Box, Icon, Text } from 'native-base'

import { AppRoutes } from '../..'
import { useDrawerStore } from '../drawerStore'

const ProfileButton = observer(() => {
  const insets = useSafeAreaInsets()
  const user = useUser()
  const navigation = useNavigation()
  const { closeDrawer } = useDrawerStore()

  const onPress = () => {
    closeDrawer()
    navigation.navigate(AppRoutes.profileUser)
  }

  return (
    <PressableOpacity
      onPress={onPress}
      paddingBottom={insets.bottom}
      borderTopWidth={1}
      _light={{
        borderTopColor: theme.colors.grayCool[200]
      }}
      _dark={{
        borderTopColor: theme.colors.grayDarkMode[700]
      }}
    >
      <Box flexDirection="row" alignItems="center" paddingX={4} paddingY={5}>
        <Avatar url={user?.picture} borderWidth={0} size={12} />
        <Box marginLeft={3}>
          <Text fontSize={15} fontFamily="Inter-Bold" noOfLines={1}>
            {user?.name}
          </Text>
          <Text fontSize={12} noOfLines={1}>
            {user?.email}
          </Text>
        </Box>
        <Box marginLeft="auto">
          <Icon
            textAlign={'right'}
            as={FontAwesome}
            name="angle-right"
            size={30}
            _light={{
              color: theme.colors.textLightMode[300]
            }}
            _dark={{
              color: theme.colors.textDarkMode[100]
            }}
          />
        </Box>
      </Box>
    </PressableOpacity>
  )
})

export { ProfileButton }
